<main class="login-main">
  <div class="login-container">

    <!-- Left side - Atlas branding -->
    <div class="atlas-side">
      <div class="atlas-content">
        <img src="assets/img/atlas.webp" alt="Atlas" class="atlas-logo" />
        <h2 class="atlas-title">Atlas / Ἄτλας</h2>
        <p class="atlas-description">{{ 'LOGIN.ATLAS_DESCRIPTION' | translate }}</p>
      </div>
    </div>

    <!-- Right side - Registration form -->
    <div class="login-side">
      <div class="login-content">

        <div class="login-heading">
          <div class="login-heading-icon"><i class="fas fa-user-plus"></i></div>
          <div>
            <h1 class="login-title">{{ 'REGISTRATION.TITLE' | translate }}</h1>
            <p class="login-subtitle">{{ 'REGISTRATION.SUBTITLE' | translate }}</p>
          </div>
        </div>

        <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="login-form">

          <!-- Messaggio di errore generale del form -->
          <div *ngIf="hasGeneralError()" class="login-alert login-alert--error">
            <i class="fa fa-exclamation-triangle"></i>
            <span>{{ getGeneralError() | translate }}</span>
          </div>

          <!-- Dealer code -->
          <label class="login-label" for="dealerCode">{{ 'REGISTRATION.DEALER_CODE_LABEL' | translate }}</label>
          <div class="login-input-wrapper" [class.is-invalid]="hasError('dealerCode')">
            <i class="fas fa-id-badge login-input-icon"></i>
            <input
              id="dealerCode"
              type="text"
              formControlName="dealerCode"
              class="login-input"
              [placeholder]="'REGISTRATION.DEALER_CODE_PLACEHOLDER' | translate"
              (input)="onInputChange()"
            />
          </div>
          <div *ngIf="hasError('dealerCode')" class="login-error">
            <i class="fas fa-exclamation-circle"></i>
            {{ getErrorMessage('dealerCode') | translate }}
          </div>

          <!-- Email -->
          <label class="login-label login-label--spaced" for="email">{{ 'REGISTRATION.EMAIL_LABEL' | translate }}</label>
          <div class="login-input-wrapper" [class.is-invalid]="hasError('email')">
            <i class="fas fa-envelope login-input-icon"></i>
            <input
              id="email"
              type="email"
              formControlName="email"
              class="login-input"
              [placeholder]="'REGISTRATION.EMAIL_PLACEHOLDER' | translate"
              (input)="onInputChange()"
              autocomplete="email"
            />
          </div>
          <div *ngIf="hasError('email')" class="login-error">
            <i class="fas fa-exclamation-circle"></i>
            {{ getErrorMessage('email') | translate }}
          </div>

          <!-- Submit -->
          <button type="submit" class="login-btn" [disabled]="isLoading">
            <ng-container *ngIf="!isLoading">
              {{ 'REGISTRATION.BUTTON' | translate }}
              <i class="fas fa-arrow-right"></i>
            </ng-container>
            <ng-container *ngIf="isLoading">
              <i class="fa-solid fa-truck-fast truck-animation"></i>
            </ng-container>
          </button>

          <div class="form-footer-register">
            {{ 'REGISTRATION.LOGIN_QUESTION' | translate }}
            <a routerLink="/login">{{ 'REGISTRATION.LOGIN_LINK' | translate }}</a>
          </div>

        </form>

      </div>
    </div>

  </div>

  <!-- Success popup -->
  <div *ngIf="registrationSuccess" class="modal-overlay">
    <div class="modal-box">
      <div class="modal-icon-wrapper">
        <i class="fa-solid fa-circle-check modal-icon"></i>
      </div>
      <h3>{{ 'REGISTRATION.SUCCESS_TITLE' | translate }}</h3>
      <p>{{ 'REGISTRATION.SUCCESS_MESSAGE' | translate }}</p>
      <button type="button" class="login-btn" (click)="closeSuccessModal()">
        {{ 'REGISTRATION.SUCCESS_BUTTON' | translate }}
      </button>
    </div>
  </div>
</main>
